import request from 'catalog/utils/axios'

export type PaymentMethodInstallment = {
  quantity: number
  price: number
  totalPrice: number
}

export type PaymentMethodItem = {
  price: number
  discountPercentage?: number | null
  priceWithoutDiscounts?: number | null
  installments?: PaymentMethodInstallment[]
}

export type PaymentMethod = {
  sellerId: string
  bankSlip?: PaymentMethodItem
  creditCard?: PaymentMethodItem
  branded?: PaymentMethodItem
  pix?: PaymentMethodItem
}

type GetPaymentMethodsResponse = {
  data: PaymentMethod[]
}

export const getPaymentMethods = async (productId: number) =>
  await request
    .get<GetPaymentMethodsResponse>(
      `/api/v3/products/${productId}/payment-methods`
    )
    .then(({ data }) => data.data)
    .catch(err => {
      throw err.response
    })
